import AddOrder from './AddOrder.vue'

export default AddOrder
